import React from "react";
import "../styling/Privacy.css";

const Privacy = () => {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>
      <p className="last-updated">
        <strong>Last updated:</strong> September 24, 2025
      </p>

      <div className="section">
        <h2>1. Introduction</h2>
        <p>
          Welcome to VOETA (“we”, “our”, “us”). We are committed to protecting
          your personal information and your right to privacy. This Privacy
          Policy describes how we collect, use, disclose, and safeguard your
          information when you visit our website or use our mobile app
          (“Services”). By accessing or using our Services, you consent to the
          practices described in this policy.
        </p>
      </div>

      <div className="section">
        <h2>2. What Information We Collect</h2>
        <p>We collect the following types of information:</p>
        <ul>
          <li>
            <strong>Personal Information:</strong> name, email address, phone
            number, address (if provided by you), account login credentials.
          </li>
          <li>
            <strong>Usage Information:</strong> how you use our Services, app
            activity, pages visited, features accessed.
          </li>
          <li>
            <strong>Device & Technical Information:</strong> IP address,
            browser type, operating system, device identifiers, location (if
            permitted).
          </li>
          <li>
            <strong>Cookies and Tracking Technologies:</strong> we use cookies,
            web beacons, and similar technologies to collect information for
            analytic and service improvement purposes.
          </li>
        </ul>
      </div>

      <div className="section">
        <h2>3. How We Use Your Information</h2>
        <p>We use your information for purposes including but not limited to:</p>
        <ul>
          <li>Providing, operating, and maintaining our Services</li>
          <li>Improving and personalizing the user experience</li>
          <li>
            Communicating with you, including sending service updates, marketing,
            or notifications (where you have agreed)
          </li>
          <li>Processing transactions and account management</li>
          <li>
            Security, fraud prevention, and compliance with legal obligations
          </li>
          <li>Analytics and performance measurement</li>
        </ul>
      </div>

      <div className="section">
        <h2>4. Share and Disclosure of Information</h2>
        <p>We may share your information with:</p>
        <ul>
          <li>
            Service providers who perform functions on our behalf (e.g. hosting,
            data storage, analytics, customer support)
          </li>
          <li>
            Law enforcement or regulatory authorities when required by law or to
            protect our rights
          </li>
          <li>
            Business transfers: if we merge with or are acquired by another
            company, your data may be transferred
          </li>
          <li>
            With your consent or as otherwise disclosed at the time you provide
            the information
          </li>
        </ul>
      </div>

      <div className="section">
        <h2>5. Data Retention</h2>
        <p>
          We retain your personal information only for as long as necessary to
          fulfill the purposes outlined in this Privacy Policy, unless a longer
          retention is required or permitted by law.
        </p>
      </div>

      <div className="section">
        <h2>6. Your Rights</h2>
        <p>Depending on your region, you may have certain rights regarding your personal data. These may include:</p>
        <ul>
          <li>The right to access your data</li>
          <li>The right to correct or update your data</li>
          <li>The right to request deletion of your data (“right to be forgotten”)</li>
          <li>The right to restrict or object to certain processing</li>
          <li>The right to data portability</li>
          <li>The right to withdraw consent where applicable</li>
        </ul>
        <p>To exercise these rights, please contact us at <strong>info@voeta.co</strong>.</p>
      </div>

      <div className="section">
        <h2>7. Cookies & Tracking</h2>
        <p>
          We use cookies and similar tracking technologies to collect and store
          information. Cookies help enhance your experience by enabling certain
          features, remembering your preferences, and allowing us to analyze use
          of our Services. You can manage cookies via your browser settings.
          Please note that disabling some cookies may impact the functionality
          of our Services.
        </p>
      </div>

      <div className="section">
        <h2>8. Security</h2>
        <p>
          We take reasonable administrative, technical, and physical measures
          designed to protect your information. However, no electronic or
          physical system is completely secure. We cannot guarantee absolute
          security, but we strive to protect your data.
        </p>
      </div>

      <div className="section">
        <h2>9. International Transfers</h2>
        <p>
          Your information may be transferred to — and maintained on — servers
          located outside your country of residence. If you reside outside the
          country(s) where our servers are located, then your data may pass
          through jurisdictions with different privacy laws. We will take steps
          to ensure that such transfers comply with applicable legal
          requirements.
        </p>
      </div>

      <div className="section">
        <h2>10. Children’s Privacy</h2>
        <p>
          Our Services are not directed to children under the age of 18 (or
          higher age depending on local law). We do not knowingly collect
          personal information from children under that age. If we learn that we
          have collected such information, we will take steps to delete it.
        </p>
      </div>

      <div className="section">
        <h2>11. Changes to this Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. When we do, we
          will post the updated version on this page with the revised “Last
          updated” date. We encourage you to review this Policy periodically.
        </p>
      </div>
    </div>
  );
};

export default Privacy;
